import { useEffect, useState } from "react";
import ListCountries from "../../components/countries/list-countries/ListCountries";
import PageBar from "../../components/dashboard/page-bar/PageBar";
import axios from "axios";
import { Loaders } from "../Loaders";

function ListCountriesPage() {
  const [loader, setLoader] = useState(false)
  const [data, setData] = useState();

  const [count, setCount] = useState(10)
  const [page, setPage] = useState(1)

  const [initialVlue, setInitialVlue] = useState({
    search: '',
  })
  const handleChange = (e) => {
    const clone = { ...initialVlue }
    const value = e.target.value
    const name = e.target.name
    clone[name] = value
    setInitialVlue(clone)
  }
  const getCountryData = async (page) => {
    setLoader(true)
    const clone = { ...initialVlue, page: page, count: count }
    try {
      const resCountryData = await axios.get(
        `https://abarishr.hennainternational.in/api/countries/all?count=${clone?.count}&page=${clone?.page}&search=${clone?.search}`
      );
      setData(resCountryData?.data);
      setLoader(false)
    } catch (error) {
      alert("error");
      setLoader(false)
    }
  };

  const reset = async (page) => {
    setLoader(true)
    const clone = { search: '', page: page, count: count }
    try {
      const resCountryData = await axios.get(
        `https://abarishr.hennainternational.in/api/countries/all?count=${clone?.count}&page=${clone?.page}&search=${clone?.search}`
      );
      setData(resCountryData?.data);
      setInitialVlue({
        search: '',
      })
      setLoader(false)
    } catch (error) {
      setLoader(false)
      alert("error");

    }
  }

  useEffect(() => {
    getCountryData(1);
  }, []);

  const onChangeVal = (e) => {
    // console.log(e);
    getCountryData(e)

  };

  return (
    <>
      {loader && <Loaders />}
      <div className="pageWrapper">
        <PageBar title=" Countries" />
        <h3 className="page-title">
          Manage Countries
        </h3>
        <ListCountries data={data} getCountryData={getCountryData} onChangeVal={onChangeVal} initialVlue={initialVlue} handleChange={handleChange} reset={reset} />
      </div>
    </>
  );
}
export default ListCountriesPage;
